
import Api from '@/api'
import Constants from '@/util/constants'

export default {
  getFeedbackCampaign (params) {
    const FEEDBACK_URL = Constants.URL.FEEDBACK_URL

    return Api.request({
      url: `${FEEDBACK_URL}form`,
      params: params
    })
  },

  submit (params) {
    return Api.request({
      url: params.serviceURL,
      data: params.serviceParams
    })
  },

  getFeedbackResponse (params) {
    const FEEDBACK_URL = Constants.URL.FEEDBACK_URL

    return Api.request({
      url: `${FEEDBACK_URL}response`,
      params: params
    })
  }
}
